<template>
  <div
    role="group"
    :aria-roledescription="t('common.slide')"
    data-slot="carousel-item"
    :class="
      cn(
        'tw:min-w-0 tw:shrink-0 tw:grow-0 tw:basis-full',
        orientation === 'horizontal' ? 'tw:pl-4' : 'tw:pt-4',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>

<script setup>
// 1. Import necessary components
defineOptions({ name: 'UiCarouselItem' });
import { cn } from '@/shared/utilities/classes';
import { useI18n } from 'vue-i18n';
import { useCarousel } from './useCarousel';

// 2. Use
const { t } = useI18n();
const props = defineProps({
  class: {
    default: undefined,
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const { orientation } = useCarousel();
// 3. Define a reactive variable
// 4. Define methods or computed properties if needed
// 5. VueJS Hooks
</script>
